;
(function ($) {
  var dataKey = 'app.offerInputCard';
  var OfferInputCard = function OfferInputCard(element, options) {
    this.element = element;
    this.init(options);
  };
  OfferInputCard.prototype = {
    attr: {
      pluginContainer: 'data-offer-inputcard'
    },
    classes: {
      inputValidationError: 'input-validation-error'
    },
    init: function init(options) {
      var _this = this;
      $.extend(_this.options, options);
      _this.initEventListeners();
      _this._autofocusOnAmountField();
    },
    initEventListeners: function initEventListeners() {
      var _this = this;
      $(document).ajaxComplete(function () {
        _this.onAjaxComplete();
      });
    },
    onAjaxComplete: function onAjaxComplete() {
      var _this = this;
      addInputValidationErrorStyling();
      function addInputValidationErrorStyling() {
        $('[' + _this.attr.pluginContainer + ']').each(function () {
          if (!$(this).find('.form-messages').hasClass('validation-summary-valid')) {
            $(this).find('input').addClass(_this.classes.inputValidationError);
          }
        });
      }
    },
    _autofocusOnAmountField: function _autofocusOnAmountField() {
      var _this = this;
      $('[' + _this.attr.pluginContainer + ']').find('input').focus();
    }
  };
  $.fn.app_offerInputCard = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof OfferInputCard) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new OfferInputCard(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);